import React, { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { apiUrl } from '../utils/api';
import { useT } from '../../i18n/LanguageContext';

const SEVERITY = { TRIAL: 'info', TRIAL_ENDED: 'warning', PAST_DUE: 'warning', READ_ONLY: 'error' };
const TEXT = { TRIAL: 'bill.bannerTrial', TRIAL_ENDED: 'bill.bannerTrialEnded', PAST_DUE: 'bill.bannerPastDue', READ_ONLY: 'bill.bannerReadOnly' };

/**
 * Slim strip under the top bar: trial days left, grace period, or read-only. Paying and comped tenants
 * (state ACTIVE) see nothing. Tapping it opens Billing. Re-checked on each screen change so it clears
 * as soon as the account is sorted out, without a reload.
 */
export default function BillingBanner() {
  const t = useT();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${apiUrl}/api/billing/status`)
      .then((res) => { if (!cancelled) setStatus(res.data); })
      .catch(() => { /* a banner is never worth an error on screen */ });
    return () => { cancelled = true; };
  }, [pathname]);

  if (!status || !SEVERITY[status.state] || pathname === '/Billing') return null;
  return (
    <Alert
      severity={SEVERITY[status.state]}
      onClick={() => navigate('/Billing')}
      sx={{ borderRadius: 0, cursor: 'pointer', py: 0.25, '& .MuiAlert-message': { fontSize: 14 } }}
    >
      {t(TEXT[status.state], { n: status.daysLeft ?? '' })}
    </Alert>
  );
}
